import { render } from "./QuickSearch.vue?vue&type=template&id=1b84f0c8&scoped=true&ts=true"
import script from "./QuickSearch.vue?vue&type=script&lang=ts"
export * from "./QuickSearch.vue?vue&type=script&lang=ts"

import "./QuickSearch.vue?vue&type=style&index=0&id=1b84f0c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b84f0c8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip,QInput,QSpinner,QChip,QSkeleton,QList,QItem,QItemSection,QAvatar,QItemLabel});qInstall(script, 'directives', {Ripple});
